import * as yup from 'yup';

import { emailRequiredValidator } from '@mopla/utils';

const DriverForgotPasswordValidationSchema = yup.object().shape({
	email: emailRequiredValidator(),
});

export default DriverForgotPasswordValidationSchema;
